import React, { useContext, useRef, useState } from "react";
import "./Product.css";
import { ThemeContext } from "../../Contexts/ThemeContext";
import { toast } from "react-hot-toast";
import { addToDb } from "../../utilities/CartDb";
import { Link, useNavigate } from "react-router-dom";
import Modal from "../Modal/Modal";
import StarRating from "../Ratings";

const Product = ({ product, list }) => {
  const { cart, setCart } = useContext(ThemeContext);
  const navigate = useNavigate();
  const dialogueRef = useRef();
  const [mouseHover, setMouseHover] = useState(false);

  const handleAddToCart = (item) => {
    let newCart = [];
    const exists = cart.find((product) => product._id == item._id);
    if (!exists) {
      item.quantity = 1;
      newCart = [...cart, item];
    } else {
      item.quantity = exists.quantity + 1;
      const rest = cart.filter((product) => product._id !== item._id);
      newCart = [...rest, item];
    }
    setCart(newCart);
    addToDb(item._id);

    toast.success("ADDED TO CART");

    // THIS LINE MAKES BOGO MODAL WORK
    window.dispatchEvent(
      new CustomEvent("addToCartTrigger", { detail: { product: item } })
    );
  };

  const handleModal = () => {
    dialogueRef.current.showModal();
    document.body.style.overflow = "hidden";
  };

  const handleBlurClose = () => {
    dialogueRef.current.close();
    document.body.style.overflow = "visible";
  };

  return (
    <div className={`product ${list ? "py-6" : ""}`}>
      <div
        onMouseEnter={() => setMouseHover(true)}
        onMouseLeave={() => setMouseHover(false)}
        className="img-container cursor-pointer"
      >
        <div
          onClick={() => navigate(`/product/${product?.slug}`)}
          className="img-div rounded relative"
        >
          {/* SALE BADGE */}
          {JSON.stringify(product?.on_sale) === "true" && (
            <div className="bg-accent absolute w-[40px] h-[40px] left-2 top-2 z-50 flex justify-center items-center rounded-full sm:w-[50px] sm:h-[50px]">
              <p style={{ color: "#fff", fontFamily: "Roboto-Regular" }}>
                -
                {Math.floor(
                  ((product.regular_price - product.sale_price) * 100) /
                    product.regular_price
                )}
                %
              </p>
            </div>
          )}

          {/* STOCK OUT BADGE */}
          {product?.stock_quantity < 1 && (
            <div className="bg-[#cccccc] absolute w-[50px] h-[50px] left-2 top-2 text-center z-50 flex justify-center items-center rounded-full sm:w-[50px] sm:h-[50px]">
              <p style={{ color: "#fff", fontFamily: "Roboto-Regular" }}>
                Stock Out
              </p>
            </div>
          )}

          {/* ✅ BOGO BADGE */}
          {product?.name?.toLowerCase().includes("bogo") && (
            <div className="bg-[#106836] absolute w-[40px] h-[40px] right-2 top-2 z-50 flex justify-center items-center rounded-full sm:w-[50px] sm:h-[50px]">
              <p
                style={{
                  color: "#fff",
                  fontFamily: "Roboto-Bold",
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                BOGO
              </p>
            </div>
          )}

          {/* PRODUCT IMAGE */}
          <img
            width={250}
            height={250}
            src={product?.images[0]?.src}
            alt=""
            className="rounded"
          />
        </div>

        {/* MODAL */}
        <Modal
          handleModal={handleModal}
          handleBlurClose={handleBlurClose}
          product={product}
          dialogueRef={dialogueRef}
        ></Modal>
      </div>

      {/* PRODUCT DETAILS */}
      <div className="product-details">
        {/* COLOR VARIATIONS */}
        {product?.variations?.length > 1 && (
          <div
            className={`flex gap-4 mb-3 h-[40px] bg-primary items-center w-[170px] md:w-[235px] lg:w-[170px] xl:w-[200px] 2xl:w-[265px] ${
              list ? "" : "mx-auto"
            }`}
          >
            {product?.variations.slice(0, 3)?.map((variation) => {
              let code = variation?.code;
              let style = { backgroundColor: code };
              return (
                <Link
                  to={`/product/${variation.product_id}`}
                  className="w-[30px] h-[30px] cursor-pointer rounded-full"
                  style={style}
                ></Link>
              );
            })}{" "}
            +
            <Link to={`/product/${product._id}`}>
              {product.variations.length - 3}
            </Link>
          </div>
        )}

        {/* PRODUCT NAME */}
        <p
          onClick={() => navigate(`/product/${product.slug}`)}
          className="limit-lines text-center cursor-pointer font-bold"
          title={product?.name}
        >
          {product?.name}
        </p>

        {/* DESCRIPTION */}
        <p>
          {list ? (
            <div
              className="limit-lines"
              dangerouslySetInnerHTML={{ __html: product?.short_description }}
            />
          ) : (
            ""
          )}
        </p>

        {/* PRICE */}
        <div className={`flex gap-2 ${list ? "" : "sm:justify-center"} `}>
          <p className="text-accent font-bold sm:text-lg">
            {JSON.stringify(product?.on_sale) === "true"
              ? product?.sale_price
              : product?.regular_price}{" "}
            BDT.
          </p>

          {JSON.stringify(product.on_sale) === "true" && (
            <p
              style={{
                textDecorationLine: "line-through",
                color: "#000",
                opacity: 0.5,
              }}
            >
              {`${product?.regular_price} BDT.`}
            </p>
          )}
        </div>

        {/* ADD TO CART BUTTON */}
        {product?.stock_quantity > 0 ? (
          <button
            onClick={() => handleAddToCart(product)}
            className="add-btn bg-accent text-white"
          >
            ADD TO CART
          </button>
        ) : (
          <button className="add-btn bg-[#cccccc] text-[#ffffff] pointer-events-none">
            ADD TO CART
          </button>
        )}
      </div>
    </div>
  );
};

export default Product;
